import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getBedroomFilterInput = (searchCriteria: SearchCriteriaModel): any[] | null => {
  if (!searchCriteria.bedroomFilter) {
    return null;
  }

  return searchCriteria.bedroomFilter.map(bedroomFilterString => Number.parseInt(bedroomFilterString, 10));
};
